export default {"src":"/_next/static/media/drive-icon.5f2b34f7.svg","height":20,"width":20};